
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interior-design-services",
      function () {
        return require("private-next-pages/interior-design-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interior-design-services"])
      });
    }
  